const { parse } = JSON;
const auth = {
  clear(key) {
    if (localStorage && localStorage.getItem(key)) {
      return localStorage.removeItem(key);
    }
    return null;
  },
  clearAppStorage() {
    return localStorage.clear();
  },
  get(key) {
    return parse(localStorage.getItem(key));
  },
  setToken(token) {
    return localStorage.setItem("token", token);
  },
  getToken() {
    return localStorage.getItem("token");
  },
  setRefreshToken(token) {
    return localStorage.setItem("refreshToken", token);
  },
  getRefreshToken() {
    return localStorage.getItem("refreshToken");
  },
  setSnsJoin(join) {
    return localStorage.setItem("snsJoin", join);
  },
  getSnsJoin() {
    return localStorage.getItem("snsJoin");
  },
};
export default auth;
